const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Feature-key -> public label (mirrors backend entitlements.FEATURES)
export const FEATURE_LABELS = {
  trading_trainer: "Trading Trainer",
  journal: "Trading Journal",
  ai_coach: "AI Coach",
  community: "Community",
  intelligence: "MBM Intelligence",
  indicators: "MBM Indicators",
  trade_setups: "MBM Trade Setups",
  trade_reviews: "Trade Reviews",
  vip_discord: "VIP Discord",
  scanner: "Market Scanner",
  one_on_one: "1-on-1 Coaching",
};

// Create a Stripe subscription checkout session and redirect. Returns false if login is required.
export async function startCheckout({ kind, itemId, period = "month" }) {
  const r = await fetch(`${API}/billing/checkout`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ kind, item_id: itemId, period, origin_url: window.location.origin }),
  });
  if (r.status === 401) return false;
  const d = await r.json();
  if (!r.ok) throw new Error((d && d.detail) || "Could not start checkout");
  window.location.href = d.url;
  return true;
}

// Open the Stripe Customer Portal (manage payment method, invoices, cancel subscription).
export async function openBillingPortal() {
  const r = await fetch(`${API}/billing/portal`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ origin_url: window.location.origin }),
  });
  if (r.status === 401) return false;
  const d = await r.json();
  if (!r.ok) throw new Error((d && d.detail) || "Could not open the billing portal");
  window.location.href = d.url;
  return true;
}
